import type { ReactElement } from 'react';
import styled from 'styled-components';

interface Props {
  /** CID with its location suffix, e.g. `2315.1`. */
  cidLabel: string;
  organization: string;
  eid: string;
  eventType: string;
}

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px 14px;
  padding: 11px 13px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 9px;
  background: rgba(8, 14, 30, 0.35);

  .cap {
    font-weight: 600;
    font-size: 9px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(176, 186, 209, 0.5);
    margin-bottom: 5px;
  }

  .val {
    font-family: 'JetBrains Mono', monospace;
    font-weight: 600;
    font-size: 12px;
    color: rgb(240, 242, 245);
  }
`;

// Read-only recap of what the ticket will be filed against.
export const TicketInfoGrid = ({
  cidLabel,
  organization,
  eid,
  eventType
}: Props): ReactElement => (
  <InfoGrid>
    <div>
      <div className='cap'>CID</div>
      <div className='val'>{cidLabel}</div>
    </div>
    <div>
      <div className='cap'>Org</div>
      <div className='val'>{organization || '—'}</div>
    </div>
    <div>
      <div className='cap'>EID</div>
      <div className='val'>{eid}</div>
    </div>
    <div>
      <div className='cap'>Event Type</div>
      <div className='val'>{eventType}</div>
    </div>
  </InfoGrid>
);
